import React from 'react';
import { motion } from 'framer-motion';
export function SlideTitle() {
  return <div className="h-full w-full bg-[#1A1A2E] text-white flex flex-col justify-between p-12 md:p-24 relative overflow-hidden" data-id="element-663">
      {/* Takeda brand background image with diagonal clip */}
      <div className="absolute inset-0 w-full h-full pointer-events-none" style={{
      clipPath: 'polygon(0 0, 55% 0, 45% 100%, 0 100%)'
    }} data-id="element-664">
        <img src="https://cdn.magicpatterns.com/uploads/4DdsdwPAh1kJGasqtHCGHc/Screenshot_2026-03-24_at_08.34.16.png" alt="" className="w-full h-full object-cover opacity-60" data-id="element-665" />
      </div>

      {/* Background decoration - angular gradient */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#E60012]/20 to-transparent pointer-events-none" data-id="element-666" />

      {/* Diagonal accent line */}
      <div className="absolute top-0 left-[45%] w-1 h-full bg-gradient-to-b from-[#FF6B6B] via-[#E60012] to-[#1A1A2E] pointer-events-none opacity-60" style={{
      transform: 'skewX(-15deg)'
    }} data-id="element-667" />

      {/* Main Content */}
      <main className="flex-1 flex flex-col justify-center z-10 max-w-[55%]" data-id="element-668">
        <motion.h1 className="text-5xl md:text-7xl font-bold leading-tight mb-6" initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-669">
          Snakker™ for <br data-id="element-670" />
          <span className="text-[#FF6B6B]" data-id="element-671">Pharma Congresses</span>
        </motion.h1>

        <motion.div className="h-1 w-32 bg-gradient-to-r from-[#E60012] to-[#FF6B6B] mb-8" initial={{
        width: 0
      }} animate={{
        width: 128
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-672" />

        <motion.p className="text-2xl text-gray-300 font-light" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} data-id="element-673">
          Full Journey Activation – From Awareness to Action
        </motion.p>
      </main>

      {/* Footer Hint */}
      <motion.footer className="flex items-center gap-2 text-gray-400 text-sm z-10" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} data-id="element-674">
        <span data-id="element-675">Press</span>
        <div className="px-2 py-1 border border-gray-600 rounded bg-white/5 font-mono text-xs" data-id="element-676">
          →
        </div>
        <span data-id="element-677">to begin</span>
      </motion.footer>
    </div>;
}